$('.start-download').each(function () {
    let filepath = $(this).data('url');

    if (typeof filepath !== 'undefined') {
        // console.log('start download: '+filepath);
        window.location.href = filepath;
    }
});